const skills = [
    {
        category: "Software Engineering",
        items: [
            "Object-Oriented Programming (OOP)",
            "Software Development Life Cycle (SDLC)",
            "System Design",
            "Data Structures & Algorithms",
        ],
    },
    {
        category: "Programming Languages",
        items: ["Java", "Python", "C++", "PHP", "JavaScript", "HTML", "CSS"],
    },
    {
        category: "Frameworks & Libraries",
        items: ["Spring Boot", "Django", "Tkinter", "React", "Bootstrap"],
    },
    {
        category: "Data Analysis & Databases",
        items: [
            "Excel",
            "PowerBI",
            "Locker Studio",
            "MS SQL Server",
            "MySQL",
            "MongoDB",
            "SSIS",
            "Azure Data Factory (ADF)",
            "Data Warehousing",
            "Jupyter Notebook",
        ],
    },
    {
        category: "System Design Tools",
        items: [
            "ERD Diagrams",
            "Star Schema",
            "Snowflake Schema",
            "Use Cases",
            "User Stories",
            "Class Diagrams",
            "Sequence Diagrams",
            "State Diagrams",
            "SRS (Software Requirements Specifications)",
        ],
    },
    {
        category: "Version Control",
        items: ["Git", "GitHub"],
    },
    {
        category: "Other Tools & Skills",
        items: [
            "Shell Scripting",
            "Figma",
            "Canva",
            "MS Office",
        ],
    },
];

export const getSkillsData = () => {
    return skills;
};
